import React, { FC, useContext, useMemo } from 'react';

interface SocialWallConfigProps {
  isLoading?: boolean;
  comments: {
    enabled: boolean;
  };
  publications: {
    enabled: boolean;
  };
  interactions: {
    enabled: boolean;
    defaultEmotes?: string[];
  };
  report: {
    enabled: boolean;
  };
}
interface SocialWallConfigType {
  isLoading?: boolean;
  commentsEnabled: boolean;
  publicationsEnabled: boolean;
  interactionsEnabled: boolean;
  reportEnabled: boolean;
  defaultInteractions: string[];
}

export const SocialWallConfig = React.createContext<SocialWallConfigType>({
  isLoading: false,
  commentsEnabled: true,
  publicationsEnabled: true,
  interactionsEnabled: true,
  reportEnabled: false,
  defaultInteractions: [],
});

export const SocialWallConfigProvider: FC<SocialWallConfigProps> = ({
  children,
  isLoading,
  comments,
  publications,
  report,
  interactions,
}) => {
  const value = useMemo(
    () => ({
      isLoading,
      commentsEnabled: comments.enabled,
      publicationsEnabled: publications.enabled,
      interactionsEnabled: interactions.enabled,
      reportEnabled: report.enabled,
      defaultInteractions: interactions.defaultEmotes || [],
    }),
    [isLoading, comments, publications, interactions, report],
  );
  return <SocialWallConfig.Provider value={value}>{children}</SocialWallConfig.Provider>;
};

export function useSocialWallConfig(): SocialWallConfigType {
  return useContext(SocialWallConfig);
}
